import { AdvancedFilterValue, FilterValueTypes } from '@access-erp/ui-components';
import { useMemo } from 'react';

export const FAILED_SO_STATUSES = [
  'Sending Failed',
  'Sending Stopped',
  'Sending Scheduling Failed',
];
export const PAUSED_SO_STATUSES = ['Billing Paused'];
export const SCHEDULED_SO_STATUSES = ['Sending Scheduled', 'Sending Paused'];
export const SENT_SO_STATUSES = ['Sent'];

export enum BILLING_SUB_MENU {
  FAILED = 'failed',
  PAUSED = 'paused',
  SCHEDULED = 'scheduled',
  SENT = 'sent',
}

const submenu_statuses = {
  [BILLING_SUB_MENU.FAILED]: FAILED_SO_STATUSES,
  [BILLING_SUB_MENU.PAUSED]: PAUSED_SO_STATUSES,
  [BILLING_SUB_MENU.SCHEDULED]: SCHEDULED_SO_STATUSES,
  [BILLING_SUB_MENU.SENT]: SENT_SO_STATUSES,
};

export function useDefaultGridFilter() {
  const subMenuBillingPage =
    window.location.pathname.includes(BILLING_SUB_MENU.FAILED) ||
    window.location.pathname.includes(BILLING_SUB_MENU.PAUSED) ||
    window.location.pathname.includes(BILLING_SUB_MENU.SCHEDULED) ||
    window.location.pathname.includes(BILLING_SUB_MENU.SENT);

  const extractSubMenuStatuses = () => {
    const subpage = Object.keys(submenu_statuses).find((status) => {
      return window.location.pathname.includes(status);
    }) as BILLING_SUB_MENU | undefined;

    if (subpage) return submenu_statuses[subpage];
    return undefined;
  };

  const filteredStatusColumn = {
    valuePath: 'status.formattedStatus',
    name: 'status',
    caption: 'Status',
    label: 'Created Date',
    type: FilterValueTypes.EnumFilter,
    value: {
      formattedStatus: {
        containsValues: extractSubMenuStatuses(),
      },
    },
  } as unknown as AdvancedFilterValue;

  const defaultCreatedDateColumn = {
    name: 'created',
    label: 'Created Date',
    type: FilterValueTypes.DateFilter,
    value: {
      lastXMonths: 3,
    },
  } as unknown as AdvancedFilterValue;

  return useMemo(
    () => ({
      defaultFilters: subMenuBillingPage ? [filteredStatusColumn] : [defaultCreatedDateColumn],
      subMenuBillingPage,
      extractSubMenuStatuses,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [subMenuBillingPage],
  );
}
